import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

import EquipmentMasterCatalogApi from "../../../../../infrastructure/api/equipmentMasterCatalog";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const empty = { id: 0, name: "", country: "", website: "", logoUrl: "", isActive: true };

const EquipmentBrandManagement = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () =>
    EquipmentMasterCatalogApi.getBrands(true).then((r) => setRows(r?.data || []));
  useEffect(() => {
    load();
  }, []);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name?.trim()) return toast.warn("نام برند الزامی است.");
    const res =
      form.id > 0
        ? await EquipmentMasterCatalogApi.updateBrand(form)
        : await EquipmentMasterCatalogApi.createBrand(form);
    if (res.ok) {
      toast.success("ذخیره شد");
      setOpen(false);
      load();
    } else toast.error(res.message || "خطا");
  };

  const headCells = [
    { id: "name", label: "نام" },
    { id: "country", label: "کشور" },
    { id: "website", label: "وب‌سایت" },
    { id: "isActive", label: "فعال", type: "boolean" },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="برندهای تجهیزات"
            action={
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setForm(empty);
                  setOpen(true);
                }}
              >
                ایجاد برند
              </Button>
            }
          />
          <CardContent>
            <EnhancedTable
              rowKey={"id"}
              rows={rows}
              headCells={headCells}
              pageSize={100}
              actions={[
                {
                  icon: <EditIcon sx={{ width: "1rem", height: "1rem" }} />,
                  onClick: (row) => {
                    setForm({ ...empty, ...row });
                    setOpen(true);
                  },
                  color: "primary",
                  tooltip: "ویرایش",
                },
              ]}
            />
          </CardContent>
        </Card>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{form.id > 0 ? "ویرایش برند" : "ایجاد برند"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="نام"
                value={form.name}
                onChange={(e) => setField("name", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="کشور"
                value={form.country}
                onChange={(e) => setField("country", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="وب‌سایت"
                value={form.website}
                onChange={(e) => setField("website", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="آدرس لوگو"
                value={form.logoUrl}
                onChange={(e) => setField("logoUrl", e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!form.isActive}
                    onChange={(e) => setField("isActive", e.target.checked)}
                  />
                }
                label="فعال"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>انصراف</Button>
          <Button variant="contained" onClick={save}>
            ذخیره
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default EquipmentBrandManagement;
